import * as BX from "main";
import {Runtime, Event, Reflection, Type} from 'main.core';
import {Overlay, SHOWN_EVENT, HIDDEN_EVENT} from "citrus.aproduction3.overlay";

const NAMESPACE = 'BX.Citrus.Aproduction3.Sidebar';
const exports = Reflection.namespace(NAMESPACE);

const defaultOptions = {
    formContainer: '#sidebar-mobile-container',
    formType: 'faq',
    isOpen: false,
};

const OPEN_CLASSES = {
    body: ['_form'],
    element: ['b-h__phone_active'],
};

export class Form extends Event.EventEmitter {
    constructor(options = defaultOptions) {
        options = Object.assign({}, defaultOptions, options || {});
        super();
        this.setEventNamespace(NAMESPACE);

        if (!options.formContainer) {
            throw new Error('Empty `formContainer` option');
        }
        if (!options.formType) {
            throw new Error('Empty `formType` option');
        }
        if (!Type.isBoolean(options.isOpen)) {
            throw new Error('Wrong isOpen value');
        }

        this.body = document.body;
        this.element = options.element || document.querySelector('.js-open-form');

        this.overlay = Overlay.getInstance();
        this.overlay.subscribe(SHOWN_EVENT, (e) => {
            if (e.data.actor !== this) {
                this.internalClose();
            }
        });
        this.overlay.subscribe(HIDDEN_EVENT, (e) => {
            if (e.data.actor === this) {
                this.close();
            }
        });

        this.formContainer = document.getElementById(options.formContainer);
        this.formType = options.formType;
        if (!this.formContainer) {
            console.warn(`Can't find sidebar container ${options.formContainer}`);
        }
        this.isFormLoaded = false;
        this.isOpen = options.isOpen;

        this.updateState();

        this.element.addEventListener('click', event => this.onClick(event))
    }

    onClick() {
        event.preventDefault();
        this.toggle();
    }

    lazyLoadForm() {
        if (this.isPreloading || this.isFormLoaded) {
            return;
        }
        this.loadForm();
    }

    updateState() {
        const method = this.isOpen ? 'add' : 'remove';

        this.element.classList[method](...OPEN_CLASSES.element);
        this.body.classList[method](...OPEN_CLASSES.body);
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        this.lazyLoadForm();
        this.overlay.show(this);
        this.updateState();
    }

    close() {
        this.overlay.hide(this);
        this.internalClose();
    }

    internalClose() {
        this.isOpen = false;
        this.updateState();
    }

    setPreloading() {
        this.isPreloading = true;
        this.formContainer.classList.add('sidebar-mobile_loading');
    }

    stopPreloading() {
        this.isPreloading = false;
        this.formContainer.classList.remove('sidebar-mobile_loading');
    }

    getFormUrl() {
        return `${BX.message('SITE_DIR') || '/'}ajax/${this.formType}.php`;
    }

    loadForm() {
        this.setPreloading();
        try {
            BX.ajax.get(this.getFormUrl(), {}, res => {
                Runtime.html(this.formContainer, res);
                this.stopPreloading();
            });
        } catch (e) {
            this.stopPreloading();
            throw e;
        }
    }
}

exports.Form = Form;
